export class FloatingMenu {
	constructor( wrapper ) {
		this.wrapper = wrapper;
		this.trigger = wrapper.querySelector( '.floatmenu__trigger' );
		this.nav     = wrapper.querySelector( '.floatmenu' );
		this.close   = wrapper.querySelector( '.floatmenu__close' );

		if ( ! this.trigger || ! this.nav ) {
			return;
		}

		this.trigger.addEventListener( 'click', () => this.open() );
		this.close?.addEventListener( 'click', () => this.closeMenu() );

		document.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' && this.wrapper.classList.contains( 'is-open' ) ) {
				this.closeMenu();
			}
		} );
	}

	open() {
		this.wrapper.classList.add( 'is-open' );
		this.trigger.setAttribute( 'aria-expanded', 'true' );
		this.close?.focus();
	}

	closeMenu() {
		this.wrapper.classList.remove( 'is-open' );
		this.trigger.setAttribute( 'aria-expanded', 'false' );
		this.trigger.focus();
	}
}

FloatingMenu.instances = Array.from(
	document.querySelectorAll( '[data-floatmenu]' )
).map( ( node ) => new FloatingMenu( node ) );
